import React from 'react'
import { formatPrice } from '../utils/formatters'

export default function AddOnCard({ addOn, selected, onToggle }) {
  const priceLabel = () => {
    if (addOn.price_pence === 0) return 'Free'
    if (addOn.price_type === 'flat') return `+${formatPrice(addOn.price_pence)}`
    return `+${formatPrice(addOn.price_pence)} pp`
  }

  return (
    <button
      type="button"
      onClick={() => onToggle(addOn.id)}
      className={`w-full text-left rounded-xl p-4 transition border-2 ${
        selected
          ? 'border-sky-500 bg-sky-50'
          : 'border-gray-200 bg-white hover:border-gray-300'
      }`}
      role="checkbox"
      aria-checked={selected}
      aria-label={`${addOn.name}, ${priceLabel()}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 ${
              selected ? 'bg-sky-500 text-white' : 'border-2 border-gray-300'
            }`}>
              {selected && (
                <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </span>
            <h4 className="font-semibold text-gray-900">{addOn.name}</h4>
          </div>
          {addOn.description && (
            <p className="text-sm text-gray-600 mt-1 ml-7">{addOn.description}</p>
          )}
        </div>
        <span className="text-sm font-bold text-sky-900 flex-shrink-0 ml-2">
          {priceLabel()}
        </span>
      </div>
    </button>
  )
}
